window.addEventListener('DOMContentLoaded', function() {
var toggle_btn = document.querySelector('.content-toggle-btn');
if(toggle_btn){
document.querySelector('.content-toggle-btn').addEventListener('click', function (e) {
    e.preventDefault();
  const content = document.querySelector('.section-boxed.collection-description');

  content.classList.toggle('expanded');

  this.textContent = content.classList.contains('expanded')
    ? 'Minder weergeven'
    : 'Meer weergeven';
});
}

document.addEventListener('click', function(e) {
  const btn = e.target.closest('.banner-review-widget .fera-reviews-header-summary');
  if (!btn) return;

  const target = document.querySelector('.fera-widget-container');

  if (target) {
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
});

  function createMobileScrollbar(containerSelector) {

    const containers = document.querySelectorAll(containerSelector);

    containers.forEach((scrollContainer) => {

      if (!scrollContainer) return;

      // avoid duplicate scrollbar
      if (scrollContainer.nextElementSibling?.classList.contains('custom-scrollbar')) {
        return;
      }

      const scrollbar = document.createElement('div');

      scrollbar.classList.add('custom-scrollbar');

      scrollbar.style.cssText = `
        width:100%;
        height:2px;
        background:#d9d9d9;
        border-radius:20px;
        overflow:hidden;
        position:relative;
      `;

      const progress = document.createElement('div');
      progress.style.cssText = `
        height:100%;
        width:30%;
        background:#111;
        border-radius:20px;
        transition:width .1s linear;
      `;
      scrollbar.appendChild(progress);
      scrollContainer.insertAdjacentElement('afterend', scrollbar);

      function updateScroll() {
        const maxScroll =
          scrollContainer.scrollWidth - scrollContainer.clientWidth;

        if (maxScroll <= 0) {
          progress.style.width = '100%';
          return;
        }

        const scrollPercent =
          scrollContainer.scrollLeft / maxScroll;

        // starts from 30%
        const width =
          30 + ((100 - 30) * scrollPercent);

        progress.style.width = width + '%';
      }

      scrollContainer.addEventListener('scroll', updateScroll);

      updateScroll();

    });

  }
  createMobileScrollbar('.feature-grid-wrapper,.feature-chart__table,.process,.table-inner-container,.trust-badges,.related-products-grid,.fera-reviews-body-items,.trust-indicators-grid,.blog-posts.scroll-area,.collection-tabs,.main-collection-tab-container scroll-carousel,.process-grid');

  fera.api.listReviews().then(({ meta, reviews }) => {
  console.log(`Found ${ meta.total_count } reviews`);
   var review_count_container = document.querySelector('.hero-banner-main .banner-review-widget .fera-averageRating-count-total');
   if(review_count_container){
    review_count_container.innerText = meta.total_count;
   }
});
});

/* 19-08-2026: mobiele collectie-intro inkorten tot ~6 regels met Lees meer-knop */
(function () {
  function initIntroClamp() {
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    if (location.pathname.indexOf('/collections/') === -1) return;
    var sections = document.querySelectorAll('.shopify-section--rich-text .prose');
    for (var i = 0; i < sections.length; i++) {
      var prose = sections[i];
      var paras = prose.querySelectorAll('p');
      for (var j = 0; j < paras.length; j++) {
        var p = paras[j];
        if (p.getBoundingClientRect().height > 260 && !p.classList.contains('cf-intro-clamp')) {
          p.classList.add('cf-intro-clamp');
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.textContent = 'Lees meer';
          btn.className = 'cf-intro-toggle';
          (function (pEl, bEl) {
            bEl.addEventListener('click', function () {
              var open = pEl.classList.toggle('cf-intro-open');
              bEl.textContent = open ? 'Lees minder' : 'Lees meer';
            });
          })(p, btn);
          p.after(btn);
          return; // alleen de eerste lange alinea
        }
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIntroClamp);
  } else {
    initIntroClamp();
  }
})();


/* 19-08-2026: tekstfix staffel-widget: "10%korting" -> "10% korting" */
(function(){
  var pogingen=0;
  var t=setInterval(function(){
    pogingen++;
    var w=document.getElementById('prvw__bundle_container');
    if(w){
      var els=w.querySelectorAll('*');
      for(var i=0;i<els.length;i++){
        var el=els[i];
        if(el.children.length===0 && /%korting/.test(el.textContent)){
          el.textContent=el.textContent.replace(/%korting/g,'% korting');
        }
      }
      clearInterval(t);
    }
    if(pogingen>20) clearInterval(t);
  }, 500);
})();


/* 19-08-2026: markeer uitverkochte PDP zodat de staffel-widget verborgen wordt */
(function(){
  function mark(){
    var atc=document.querySelector('.product form[action*="/cart/add"] button[type="submit"]');
    if(atc && atc.disabled){ document.body.classList.add('cf-uitverkocht'); }
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', mark); } else { mark(); }
  setTimeout(mark, 1500);
})();


/* 25-08: footer-menu's inklapbaar op mobiel (patroon zoals cloudpillo) */
(function(){
  if (window.cf2FooterAcc) return; window.cf2FooterAcc = true;
  var mq = window.matchMedia('(max-width: 767px)');

  function blokken(){
    return Array.prototype.slice.call(
      document.querySelectorAll('footer .footer__block--menu, footer .footer__block--text')
    );
  }
  function zet(b, open){
    var kop = b.querySelector('.cf2-facc__kop');
    var paneel = b.querySelector('.cf2-facc__paneel');
    if (!paneel) return;
    b.classList.toggle('is-open', open);
    if (kop) kop.setAttribute('aria-expanded', open ? 'true' : 'false');
    /* display i.p.v. max-height: het thema overschrijft max-height op dit element */
    paneel.style.display = open ? '' : 'none';
    if (open) { paneel.classList.remove('cf2-facc__in'); void paneel.offsetWidth; paneel.classList.add('cf2-facc__in'); }
  }
  function bouw(){
    blokken().forEach(function(b){
      var kop = b.querySelector('p.bold');
      var paneel = kop && kop.nextElementSibling;
      if (!kop || !paneel) return;
      if (!b.dataset.cf2Acc) {
        b.dataset.cf2Acc = '1';
        kop.classList.add('cf2-facc__kop');
        kop.setAttribute('role','button');
        kop.setAttribute('tabindex','0');
        paneel.classList.add('cf2-facc__paneel');
        var toggle = function(){
          if (!mq.matches) return;
          zet(b, !b.classList.contains('is-open'));
        };
        kop.addEventListener('click', toggle);
        kop.addEventListener('keydown', function(e){
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
        });
      }
      if (mq.matches) {
        zet(b, b.classList.contains('is-open'));
      } else {
        b.classList.remove('is-open');
        var p = b.querySelector('.cf2-facc__paneel');
        if (p) { p.style.display = ''; p.classList.remove('cf2-facc__in'); }
        if (kop) kop.setAttribute('aria-expanded','true');
      }
    });
  }
  function init(){ bouw(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  mq.addEventListener ? mq.addEventListener('change', bouw) : mq.addListener(bouw);
})();


/* 28-08: SEO-tekst onder de FAQ inklappen met 'Lees meer' */
(function(){
  function vouw(){
    var grid = document.querySelector('.shopify-section[id$="__main"]');
    if(!grid || !grid.querySelector('product-card, .product-card')) return;
    var alles = Array.prototype.slice.call(document.querySelectorAll('.shopify-section[id*="__rich_text"]'));
    if(!alles.length) return;
    alles.forEach(function(sec){
      // alleen de teksten onder het productoverzicht, niet de intro erboven
      if(!(grid.compareDocumentPosition(sec) & Node.DOCUMENT_POSITION_FOLLOWING)) return;
      if(sec.dataset.cf2Fold) return;
      var doel = sec.querySelector('.prose') || sec.querySelector('.section-stack') || sec.firstElementChild;
      if(!doel || doel.getBoundingClientRect().height < 520) return;
      sec.dataset.cf2Fold = '1';
      doel.classList.add('cf2-fold');
      var vlak = doel.closest('.section') || sec;
      var kleur = getComputedStyle(vlak).backgroundColor;
      if(kleur && kleur !== 'rgba(0, 0, 0, 0)') doel.style.setProperty('--cf2-fold-bg', kleur);
      var knop = document.createElement('button');
      knop.type = 'button';
      knop.className = 'cf2-fold__btn';
      knop.textContent = 'Lees meer';
      knop.setAttribute('aria-expanded','false');
      doel.parentNode.insertBefore(knop, doel.nextSibling);
      knop.addEventListener('click', function(){
        var open = doel.classList.toggle('is-open');
        knop.textContent = open ? 'Lees minder' : 'Lees meer';
        knop.setAttribute('aria-expanded', open ? 'true' : 'false');
        if(!open) doel.scrollIntoView({block:'start'});
      });
    });
  }
  if(document.readyState !== 'loading') vouw(); else document.addEventListener('DOMContentLoaded', vouw);
})();


/* 02-09: collecties: uitverkochte producten altijd achteraan het raster */
(function(){
  function uitverkocht(kaart){
    if (kaart.querySelector('[class*="sold-out"], [class*="sold_out"]')) return true;
    return !kaart.querySelector('.product-card__quick-buy');
  }
  var bezig=false;
  function sorteer(){
    if(bezig) return;
    var lijst=document.querySelector('product-list');
    if(!lijst) return;
    var kaarten=Array.prototype.slice.call(lijst.querySelectorAll('product-card'));
    if(kaarten.length<2) return;
    var uit=kaarten.filter(uitverkocht);
    if(!uit.length || uit.length===kaarten.length) return;
    bezig=true;
    uit.forEach(function(k){ lijst.appendChild(k); });
    bezig=false;
  }
  function init(){
    sorteer();
    var lijst=document.querySelector('product-list');
    if(!lijst) return;
    var timer=null;
    new MutationObserver(function(){
      if(bezig) return;
      clearTimeout(timer); timer=setTimeout(sorteer,150);
    }).observe(lijst,{childList:true});
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
})();
